import { ReactNode } from "react";
import { ActionReportProfileSection } from "../ActionReportProfileSection/ActionReportProfileSection";
import NoDataValue from "../../../../common/components/NoDataValue/NoDataValue";
import "./MobileCard.scss";

export type MobileCardProps = {
  aboName: ReactNode;
  aboNumber: ReactNode;
  aff?: string;
  abo?: string;
  aboOnclick?: (affAbo: string) => void;
  includeGlobalMB?: boolean;
  kpiRows: { title: ReactNode; value: ReactNode; ariaLabel?: string; fullWidth?: boolean }[];
  watchlist?: boolean;
  toggleWatchlist?: () => void;
  isLoading?: boolean;
  tags?: {
    isProvisional?: boolean;
    isFirstContractYear?: boolean;
    businessNatureTag?: "abo" | "member" | "customer" | "guestCustomer";
    conversionType?: string;
    upForRenewal?: boolean;
    level?: number;
    businessNature?: string;
    showTagForDeepCustomers?: boolean;
    allowCustomerDetails?: boolean;
  };
  allowCustomerDetails?: boolean;
  isInternational?: boolean;
  countryCode?: string;
  onAboNameClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  isChina?: boolean;
  isSelected?: boolean;
  phoneNumber?: string;
  onPhoneTrack?: () => void;
  onMessageTrack?: () => void;
  whatsAppNumber?: string;
  whatsAppLoading?: boolean;
  onWhatsAppTrack?: () => void;
  rankBadge?: number;
  photoUrl?: string;
  showImageBlock?: boolean;
  style?: "standard" | "no-divider";
  isConfidential?: boolean;
};

export const MobileCard = ({
  aboName,
  aboNumber,
  aff,
  abo,
  aboOnclick,
  includeGlobalMB,
  watchlist,
  toggleWatchlist,
  kpiRows,
  isLoading,
  tags,
  isInternational,
  countryCode,
  onAboNameClick,
  isChina = false,
  isSelected = false,
  phoneNumber,
  onPhoneTrack,
  onMessageTrack,
  whatsAppNumber,
  whatsAppLoading,
  onWhatsAppTrack,
  allowCustomerDetails = false,
  rankBadge,
  photoUrl,
  showImageBlock = false,
  style = "standard",
  isConfidential = false,
}: MobileCardProps) => {
  const cardClassName = [
    "arMobileCard",
    isChina ? "arMobileCard--china" : "",
    isSelected ? "arMobileCard--selected" : "",
    style === "no-divider" ? "arMobileCard--no-divider" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={cardClassName}>
      <ActionReportProfileSection
        variant="mobile"
        aboName={aboName}
        aboNumber={typeof aboNumber === "string" ? aboNumber : (abo ?? "")}
        aff={aff}
        abo={abo}
        aboOnclick={aboOnclick}
        includeGlobalMB={includeGlobalMB}
        rankBadge={rankBadge}
        photoUrl={photoUrl}
        isChina={isChina}
        isInternational={isInternational}
        countryCode={countryCode}
        tags={tags}
        allowCustomerDetails={allowCustomerDetails}
        watchlist={watchlist}
        toggleWatchlist={toggleWatchlist}
        onAboNameClick={onAboNameClick}
        isLoading={isLoading}
        phoneNumber={phoneNumber}
        onPhoneTrack={onPhoneTrack}
        onMessageTrack={onMessageTrack}
        whatsAppNumber={whatsAppNumber}
        whatsAppLoading={whatsAppLoading}
        onWhatsAppTrack={onWhatsAppTrack}
        showImageBlock={showImageBlock}
        privacyFlag={isConfidential}
      />
      {!isChina && (
        <section className="arMobileCard__kpiList">
          {kpiRows.map((item, index) => (
            <div
              className={`arMobileCard__kpiItem${item.fullWidth ? " arMobileCard__kpiItem--fullWidth" : ""}`}
              key={`${aboNumber}-kpi${index + 1}`}
            >
              <div
                className="arMobileCard__kpiTitle"
                data-testid={`ar-mobile-kpi-title-${
                  typeof item.title === "string"
                    ? item.title
                        .toLowerCase()
                        .replace(/\s+/g, "-")
                        .replace(/[^a-z0-9-]/g, "")
                    : index
                }`}
              >
                {item.title}
              </div>
              <div className="arMobileCard__kpiValue">
                {item.ariaLabel && item.value === "--" ? <NoDataValue label={item.ariaLabel} /> : item.value}
              </div>
            </div>
          ))}
        </section>
      )}
    </div>
  );
};
